import { defineComponent, inject } from 'vue';
import { IMsg } from '_c/typings/model/im';
import { UserManager } from '_c/business/manager/user';
import { MsgL2Type } from '_c/typings/proto';
import EventBus from '_c/util/event-bus';
import { ChatPageEvents, ChatPageEventType } from '_c/typings/event/global';
import { createMessageUniqueKey } from '@/business/chat/message-util';
import { report } from '_c/business/api/report';

export default defineComponent({
  name: 'RevokeMessageView',
  setup(): {
    messageData: IMsg,
    chatPageEventBus?: EventBus<ChatPageEvents>
  } {
    return {
      messageData: inject('messageData') as IMsg,
      chatPageEventBus: inject<EventBus<ChatPageEvents>>('chatPageEventBus'),
    };
  },
  data(): {
    showReedit: boolean,
    timer?: NodeJS.Timer
  } {
    return {
      showReedit: false,
      timer: undefined,
    };
  },
  computed: {
    isSupportReedit(): boolean {
      return this.messageData.l2Type === MsgL2Type.MsgL2TypeText;
    },
    isSelf(): boolean {
      const currentUid = UserManager.getInstance().getCurrentUid();
      return `${currentUid}` === `${this.messageData.senderUserInfo?.uid}`;
    },
    revokeUsername(): string | undefined {
      return this.isSelf ? '你' : this.messageData.senderUserInfo?.groupNickname;
    },
  },
  created() {
    if (this.isSupportReedit && this.isSelf) {
      const { revokeMessageTimestampConfig } = this.$store.state.chat;
      const messageUniqueId = createMessageUniqueKey(this.messageData);
      const timestamp = revokeMessageTimestampConfig[messageUniqueId];
      if (timestamp) {
        const endTimestamp = timestamp + 5 * 60 * 1000;
        const nowTimestamp = Date.now();
        const diff = endTimestamp - nowTimestamp;
        if (diff >= 0) {
          this.showReedit = true;
          this.timer = setTimeout(() => {
            this.showReedit = false;
            this.$store.commit('chat/setRevokeMessageTimestamp', {
              messageUniqueId,
              timestamp: 0,
            });
          }, diff);
        } else {
          this.$store.commit('chat/setRevokeMessageTimestamp', {
            messageUniqueId,
            timestamp: 0,
          });
        }
      }
    }
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    onClickReeditHandler() {
      this.chatPageEventBus?.emit(ChatPageEventType.clickMessageReedit, {
        messageData: this.messageData,
      });
      report({
        reportParamsList: [{
          operId: '1913000110204',
          groupId: this.$store.state.group.selectGroupId,
          channelId: this.$store.state.group.selectChannelId,
          messageId: this.messageData.origin?.ID,
        }],
      });
    },
  },
});
